"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _config = _interopRequireDefault(require("../../../../../targets/cord_eurofh_teams/config.js"));

var _DataStore = _interopRequireWildcard(require("../../../../KESI2/Stores/DataStore2"));

var QuizPushHelper = function QuizPushHelper() {
  (0, _classCallCheck2["default"])(this, QuizPushHelper);
  (0, _defineProperty2["default"])(this, "storeMessage", /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(data) {
      var messages, maxMessageCount, newMessage;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _DataStore["default"].getElementByPath(_DataStore.DATA_STORE_PATHS.QD_MESSAGES);

            case 2:
              _context.t0 = _context.sent;

              if (_context.t0) {
                _context.next = 5;
                break;
              }

              _context.t0 = [];

            case 5:
              messages = _context.t0;
              maxMessageCount = 7;

              if (messages.length > maxMessageCount) {
                console.log("QuizPushHelper waitingmessages: too many messages ( more than ".concat(maxMessageCount, ")"));
                messages.shift();
              }

              newMessage = data.body;

              if (!messages.includes(newMessage)) {
                console.log('waitingmessages: message already present');
                messages.push(newMessage);
              }

              console.log('storing message', data.body, messages); // move that to the datastore so we can store messages when in single player

              _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_MESSAGES, messages);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
  (0, _defineProperty2["default"])(this, "getAllWaitingMessages", function () {
    var messages = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_MESSAGES) || [];
    console.log('QuizPushHelper getting all messages', messages);
    return messages;
  });
  (0, _defineProperty2["default"])(this, "resetAllMessages", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            console.log('QuizPushHelper resetting messages');
            _context2.next = 3;
            return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_MESSAGES, []);

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })));
};

var instance = new QuizPushHelper();
var _default = instance;
exports["default"] = _default;